import { FaCartShopping } from "react-icons/fa6";
import { useEffect, useState } from "react";
import {
  getServicePage,
  postData,
  urlAPI,
} from "../../services/api.services";
import Marquee from "react-fast-marquee";
import { Modal } from "@mui/material";
import { FaCheckCircle } from "react-icons/fa";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { Helmet } from "react-helmet";
import DOMPurify from "dompurify";
import ellipse1 from "../../assets/images/Ellipse1.png";
import ellipse2 from "../../assets/images/Ellipse2.png";
import { useAppContext } from "../../context/AppContext";

export const ServiceById = () => {
  const { slug } = useParams();
  const { contact, landingpage } = useAppContext();

  const [sortOrder, setSortOrder] = useState("asc");
  const [data, setData] = useState({});
  const [homepageVal, setHomepage] = useState([]);
  const [contactVal, setContact] = useState([]);

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    async function fetchData() {
      await getServicePage(slug, (data) => {
        setData(data?.data);
      });
    }
    fetchData();
  }, [slug]);

  useEffect(() => {
    if (landingpage) setHomepage(landingpage)
    if (contact) setContact(contact)
  }, [landingpage, contact]);

  const handleSortOrderChange = (e) => {
    setSortOrder(e.target.value);
  };

  const sortedProducts = data?.section7?.products?.sort((a, b) => {
    if (sortOrder === "asc") {
      return a.product_name.localeCompare(b.product_name);
    } else {
      return b.product_name.localeCompare(a.product_name);
    }
  });

  const [newsPost, setNewsPost] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleInput = (event) => {
    const { name, value } = event.target;
    let filteredValue = value;

    // If the input field is 'phone', apply filtering
    if (name === "phone") {
      filteredValue = value.replace(/[^0-9+]/g, ""); // Allow only numbers and '+'
    }

    // Update the state with the filtered value
    setNewsPost({
      ...newsPost,
      [name]: filteredValue,
    });
  };

  const handlePost = async (event) => {
    event.preventDefault();
    // console.log(newsPost, 'news ----1');

    await postData("customer", newsPost);
    setOpenModal(true);
    // console.log('Data posted successfully!');
  };

  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpanded2, setIsExpanded2] = useState(false);
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  function truncateHtml(html, limit) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.slice(0, limit);
  }

  function getPlainTextLength(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return (tempDiv.textContent || "").trim().length;
  }

  const htmlContent = data?.section1?.description || "";
  const plainTextLength = getPlainTextLength(htmlContent);
  const isLong = plainTextLength > 400;
  const truncatedText = truncateHtml(htmlContent, 400);

  return (
    <>
      <Helmet>
        <title>{data?.service?.meta_title}</title>
        <meta name="description" content={data?.service?.meta_description} />
        <meta name="keywords" content={data?.service?.keywords} />
        <link
          rel="canonical"
          href={`https://www.prismamultimedia.com/services/${data?.service?.id}/${data?.service?.slug}`}
        />
      </Helmet>
      <nav className="block md:hidden text-sm text-gray-600 px-4 py-4 bg-white z-10 relative" aria-label="Breadcrumb">
        <ol className="flex items-center flex-wrap">
          <li>
            <Link to="/" className="hover:underline text-blue-600">Home</Link>
          </li>
          <li><IoIosArrowForward className="mx-2 text-gray-400" /></li>
          <li>
            <Link to="/services" className="hover:underline text-blue-600">Services</Link>
          </li>
          <li><IoIosArrowForward className="mx-2 text-gray-400" /></li>
          <li className="text-gray-800">{data?.service?.name || "Service"}</li>
        </ol>
      </nav>
      <div className="w-[100vw]">
        {/* hero section */}
        <section className="mx-auto">
          {/* Gambar background */}
          <div className="w-full h-screen relative">
            {data?.section1?.image_url && (
              <img
                src={urlAPI + data.section1.image_url}
                alt={data.section1.image_alt || "gambar section 1"}
                className="mx-auto lg:h-96 w-full object-cover"
              />
            )}
            <div className="absolute w-full h-full top-0 left-0 bg-gray-900/30"></div>
            <div className="absolute w-full h-full top-0 left-0">
              <img src={ellipse1} alt="" />
            </div>
            <div className="absolute w-full h-full top-0 left-0">
              <img src={ellipse2} alt="" className="w-full h-screen" />
            </div>
            <div className="absolute top-0 w-full h-full flex flex-col justify-center text-center text-white p-4 amiri-regular gap-3">
              <h1 className="lg:text-5xl text-2xl tracking-widest font-semibold text-white">
                {data?.section1?.title}
              </h1>
              <h1 className="text-center tracking-widest text-2xl md:text-3xl lg:text-5xl  text-white font-semibold">
                {data?.service?.name}
              </h1>
              <div className="text-white text-base text-center max-w-3xl mx-auto">
                <div
                  className={`tracking-wider leading-normal text-white text-base text-center max-w-3xl mx-auto ${
                    isExpanded2 ? "mb-4" : "mb-2"
                  }`}
                  // dangerouslySetInnerHTML={{
                  //   __html: data?.section1?.description,
                  // }}
                  dangerouslySetInnerHTML={{
                    __html: isExpanded2
                      ? DOMPurify.sanitize(htmlContent)
                      : DOMPurify.sanitize(truncatedText),
                  }}
                />
                {!isExpanded2 && isLong && (
                  <span
                    className="text-white underline hover:text-blue-300 cursor-pointer"
                    onClick={() => setIsExpanded2(true)}
                  >
                    &nbsp;Read More
                  </span>
                )}

                {isExpanded2 && isLong && (
                  <button
                    onClick={() => setIsExpanded2(false)}
                    className="text-white underline hover:text-blue-100"
                  >
                    Show Less
                  </button>
                )}
              </div>
              <button
                onClick={() => {
                  document
                    .getElementById("deskripsi")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
                className="max-w-xl mx-auto capitalize bg-darkColor text-white py-4 px-4 rounded-full"
              >
                Lihat selengkapnya
              </button>
            </div>
          </div>
          {/* <div className=" w-full h-screen overflow-hidden">
            <img
              src={urlAPI + data?.section1?.image_url}
              alt="Banner"
              className="absolute top-0 left-0 inset-0 w-full h-full object-cover"
            />
          </div>
           <img
            src={urlAPI + data?.section1?.image_url}
            alt="Banner"
            className="absolute top-0 left-0 mx-auto lg:h-96 w-full object-cover z-10"
          /> *
          <div className="bg-gray-50 w-full h-full absolute top-0 left-0 z-0"></div>
          <div className="relative z-10 flex flex-col items-center justify-center gap-6">
            <h1 className="text-center text-2xl md:text-3xl lg:text-5xl font-semibold">
              {data?.section1?.title}
            </h1>
            <h1 className="text-center text-2xl md:text-3xl lg:text-5xl  text-darkColor font-semibold">
              {data?.service?.name}
            </h1>
            <div
              className=" text-gray-600 text-base text-center lg:text-base max-w-xl mx-auto"
              dangerouslySetInnerHTML={{ __html: data?.section1?.description }}
            />
            <button
              onClick={() => {
                document
                  .getElementById("deskripsi")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="capitalize bg-darkColor text-white py-2 px-4 rounded-full"
            >
              Lihat selengkapnya
            </button>
          </div> */}
        </section>

        <nav className="hidden md:block text-sm text-gray-600 my-8 px-4 max-w-screen-xl mx-auto" aria-label="Breadcrumb">
          <ol className="flex items-center flex-wrap">
            <li>
              <Link to="/" className="hover:underline text-blue-600">Home</Link>
            </li>
            <li><IoIosArrowForward className="mx-2 text-gray-400" /></li>
            <li>
              <Link to="/services" className="hover:underline text-blue-600">Services</Link>
            </li>
            <li><IoIosArrowForward className="mx-2 text-gray-400" /></li>
            <li className="text-gray-800">{data?.service?.name || "Service"}</li>
          </ol>
        </nav>

        {/* description */}
        <section
          id="deskripsi"
          className={`max-w-screen-xl mx-auto md:flex items-center text-center lg:text-start justify-between py-10 lg:py-6`}
        >
          <div
            className={`px-5 text-center md:text-left md:w-3/6 my-auto pt-5 md:pt-0`}
          >
            <h4 className="capitalize text-sm lg:text-base font-semibold bg-clip-text text-transparent bg-gradient-to-r from-[#0E46A3] to-[#031736]">
              {data?.section2?.subtitle}
            </h4>
            <div className="text-2xl md:text-3xl leading-normal tracking-wide font-semibold">
              {data?.section2?.title}
              <hr
                className={`h-1 w-1/2 mt-2 mx-auto md:mx-0 lg:mt-5 bg-gradient-to-r from-[#0E46A3] to-[#031736] border-t`}
              />
            </div>
            <div
              className="py-5 text-black text-sm lg:text-base text-justify"
              dangerouslySetInnerHTML={{ __html: data?.section2?.description }}
            />
          </div>
          <div className="pt-10 md:pt-0 md:w-3/6 m-auto px-5">
            {data?.section2?.image_url && (
              <img
                src={urlAPI + data.section2.image_url}
                alt={data.section2.image_alt || "gambar section 2"}
                className="mx-auto lg:h-96 w-full object-cover"
              />
            )}
          </div>
        </section>

        {/* keuntungan */}
        <section className="bg-[#f5f5f5]">
          <div
            className={`max-w-screen-xl mx-auto md:flex items-center text-center lg:text-start justify-between py-10 lg:py-40`}
          >
            <div
              className={`px-5 text-center md:text-left md:w-3/6 my-auto pt-5 md:pt-0`}
            >
              <h4 className="capitalize text-sm lg:text-base font-semibold bg-clip-text text-transparent bg-gradient-to-r from-[#0E46A3] to-[#031736]">
                {data?.section3?.subtitle}
              </h4>
              <div className="text-2xl md:text-3xl leading-normal tracking-wide font-semibold">
                {data?.section3?.title}
                <hr
                  className={`h-1 w-1/2 mt-2 mx-auto md:mx-0 lg:mt-5 bg-gradient-to-r from-[#0E46A3] to-[#031736] border-t`}
                />
              </div>
              <div
                className="py-5 text-black text-sm lg:text-base text-justify"
                dangerouslySetInnerHTML={{
                  __html: data?.section3?.description,
                }}
              />
            </div>
            <div className="pt-10 md:pt-0 md:w-3/6 m-auto px-5">
              {data?.section3?.image_url && (
                <img
                  src={urlAPI + data.section3.image_url}
                  alt={data.section3.image_alt || "gambar section 3"}
                  className="mx-auto lg:h-96 w-full object-cover"
                />
              )}
            </div>
          </div>
        </section>

        {/* marquee */}
        <section id="teams">
          {/* <div className="relative flex py-5 items-center">
            <div className="flex-grow border-t border-gray-400"></div>

            <div className="flex-grow border-t border-gray-400"></div>
          </div> */}
          <div className="my-10 py-5">
            <Marquee direction="right" speed={100} delay={5}>
              {data?.section4 &&
                data?.section4?.map((item) => (
                  <div className="mx-4">
                    <img
                      src={encodeURI(urlAPI + item.image_url)}
                      alt={item.image_alt || item.name}
                      className="lg:grayscale hover:grayscale-0 h-10 w-24 md:h-14 md:w-32 lg:w-44 object-contain m-auto"
                    />
                  </div>
                ))}
            </Marquee>
          </div>
        </section>
        <section className="bg-[#f5f5f5]">
          <div className="max-w-screen-xl mx-auto pb-10 md:pb-20">
            <div className="mx-auto flex flex-col items-center justify-center gap-4 py-10 md:py-20 ">
              <h1 className="text-2xl md:text-3xl leading-normal tracking-wide font-semibold text-center px-5 md:px-0">
                {data?.section5?.title}
              </h1>
              {/* <p
              className={`text-base text-justify text-gray-600 font-medium w-full px-5 md:px-0 md:w-[80%] ${
                isExpanded ? "mb-4" : "mb-2"
              }`}
            >
              {isExpanded
                ? data?.section6?.description || "Description not available."
                : `${
                    data?.section6?.description.slice(0, 500) ||
                    "Description not available."
                  }...`}
            </p> */}
              <p
                className={`text-base text-justify text-gray-600 font-medium w-full px-5 md:px-0 md:w-[80%] ${
                  isExpanded ? "mb-4" : "mb-2"
                }`}
                dangerouslySetInnerHTML={{
                  __html: isExpanded
                    ? DOMPurify.sanitize(
                        data?.section5?.description ||
                          "Description not available."
                      )
                    : DOMPurify.sanitize(
                        truncateHtml(data?.section5?.description || "", 500) +
                          "..."
                      ),
                }}
              />
              <button
                onClick={toggleExpand}
                className="border border-darkColor text-darkColor py-2 px-4 rounded-full hover:bg-darkColor hover:text-white focus:outline-none capitalize"
              >
                {isExpanded ? "lihat sedikit" : "Lihat semua"}
              </button>
            </div>
          </div>
        </section>

        {/* galerry */}
        {data?.section6 && (
          <div className=" text-center pb-10 md:pb-20">
            <h1 className="uppercase text-2xl md:text-4xl py-10 md:py-20">
              Galery
            </h1>

            <div className="flex flex-wrap lg:w-3/4 m-auto gap-8 gap-x-0">
              {data?.section6?.map((item, index) => (
                <div className="m-auto group/item lg:grayscale hover:grayscale-0">
                  <img
                    src={urlAPI + item.image_url}
                    alt={item.image_alt || item.name}
                    className="md:h-80 md:w-80 object-cover"
                  />
                  {/* <div className="invisible group-hover/item:visible flex absolute w-full h-full top-0 left-0 bg-darkColor/40 text-white">
                  <div className="m-auto text-2xl font-medium">{item.name}</div>
                </div> */}
                </div>
              ))}
            </div>
            {/* <div className="pt-10">
            <a
              href={homepageVal.landing_portfolio_button_link}
              className="hover:bg-darkColor hover:text-white bg-transparent text-darkColor py-2 px-5 rounded border border-darkColor"
            >
              {homepageVal.landing_portfolio_button_label}
            </a>
          </div> */}
          </div>
        )}

        {/* pricing */}
        <section id="lists-prices">
          <div class="bg-gray-100 pt-10 pb-20">
            <div class="p-4 mx-auto lg:max-w-7xl sm:max-w-full">
              <div class="flex flex-col justify-center items-center gap-6 mb-6">
                <h2 className="capitalize text-sm lg:text-base font-semibold bg-clip-text text-transparent bg-gradient-to-r from-[#0E46A3] to-[#031736]">
                  {data?.section7?.subtitle}
                </h2>
                <h1 class="text-center text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#0E46A3] to-[#031736]">
                  {data?.section7?.title}
                </h1>
              </div>

              <div className="flex justify-end mb-4 text-sm">
                <select
                  value={sortOrder}
                  onChange={handleSortOrderChange}
                  className="bg-white border border-gray-300 rounded pr-4 pl-1 py-2 mr-2"
                >
                  <option value="asc">Sort A-Z</option>
                  <option value="desc">Sort Z-A</option>
                </select>
              </div>
              <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 max-xl:gap-4 gap-6">
                {sortedProducts?.map((item) => (
                  <a
                    href={`/pricing/${item.id}`}
                    className="bg-white rounded-2xl p-5 cursor-pointer hover:-translate-y-2 transition-all relative"
                    key={item.id}
                  >
                    <div className="bg-gray-100 w-10 h-10 flex items-center justify-center rounded-full cursor-pointer absolute bottom-4 right-4">
                      <FaCartShopping className="fill-[#0E46A3] inline-block" />
                    </div>
                    <div className="h-[210px] overflow-hidden mx-auto aspect-w-16 aspect-h-8 md:mb-2 mb-4">
                      <img
                        src={urlAPI + item.image_url}
                        alt={item.image_alt || `Product ${item.id}`}
                        className="h-full w-full object-cover rounded"
                      />
                    </div>
                    <div>
                      <h3 className="text-lg font-extrabold text-gray-800">
                        {item.product_name}
                      </h3>
                      <div
                        className="text-gray-600 text-sm mt-2"
                        dangerouslySetInnerHTML={{
                          __html: item.product_description,
                        }}
                      />
                    </div>
                  </a>
                ))}
                {/* <div class="bg-white rounded-2xl p-5 cursor-pointer hover:-translate-y-2 transition-all relative">
                      <div
                        class="bg-gray-100 w-10 h-10 flex items-center justify-center rounded-full cursor-pointer absolute top-4 right-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18px" class="fill-gray-800 inline-block" viewBox="0 0 64 64">
                          <path
                            d="M45.5 4A18.53 18.53 0 0 0 32 9.86 18.5 18.5 0 0 0 0 22.5C0 40.92 29.71 59 31 59.71a2 2 0 0 0 2.06 0C34.29 59 64 40.92 64 22.5A18.52 18.52 0 0 0 45.5 4ZM32 55.64C26.83 52.34 4 36.92 4 22.5a14.5 14.5 0 0 1 26.36-8.33 2 2 0 0 0 3.27 0A14.5 14.5 0 0 1 60 22.5c0 14.41-22.83 29.83-28 33.14Z"
                            data-original="#000000"></path>
                        </svg>
                      </div>
                      <div class="w-11/12 h-[210px] overflow-hidden mx-auto aspect-w-16 aspect-h-8 md:mb-2 mb-4">
                        <img src="https://readymadeui.com/images/product9.webp" alt="Product 1"
                          class="h-full w-full object-contain" />
                      </div>
                      <div>
                        <h3 class="text-lg font-extrabold text-gray-800">Sole Elegance</h3>
                        <p class="text-gray-600 text-sm mt-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        <h4 class="text-lg text-gray-800 font-bold mt-4">$10</h4>
                      </div>
                    </div> */}
              </div>
            </div>
          </div>
        </section>

        {/* contact */}
        <div className="max-w-screen-xl mx-auto pb-10 md:pb-20">
          <div className="mx-auto flex flex-col items-center justify-center gap-4 py-10 md:py-20 ">
            <h1 className="text-2xl md:text-3xl leading-normal tracking-wide font-semibold text-center px-5 md:px-0 uppercase pt-5">
              Book now
            </h1>
          </div>

          <div className="md:flex w-11/12 lg:w-3/4 m-auto border rounded-lg bg-[#f5f5f5]">
            <div className="md:w-3/6 md:order-2 h-72 md:h-[29rem]">
              <img
                className="md:img-layout2 mx-auto h-full w-full object-cover rounded-t md:rounded-r-lg"
                src={urlAPI + contactVal.landing_contact_image}
                alt={contactVal?.landing_contact_image_alt || ""}
              />
              <div className="relative w-full h-full bottom-72 md:bottom-[29rem] left-0 bg-darkColor/30 rounded-t md:rounded-r-lg"></div>
            </div>

            <div className="px-5 text-left md:w-3/6 m-auto pt-5 md:pt-0 md:order-1 bg-clip-text text-transparent bg-gradient-to-r from-[#0E46A3] to-[#031736] md:h-[29rem]">
              <form onSubmit={handlePost}>
                <div className="sm:col-span-4 text-black py-5 w-3/4 m-auto">
                  <div>
                    <div className="mx-auto sm:max-w-md">
                      <p className="text-sm my-1">Name</p>
                      <input
                        type="text"
                        id="fullname"
                        name="name"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        placeholder="Full Name"
                        value={newsPost.name}
                        onChange={handleInput}
                      />
                    </div>
                  </div>
                  <div className="my-4">
                    <div className="mx-auto sm:max-w-md">
                      <p className="text-sm my-1">Email</p>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        placeholder="Email"
                        value={newsPost.email}
                        onChange={handleInput}
                      />
                    </div>
                  </div>
                  <div className="my-4">
                    <div className="mx-auto sm:max-w-md">
                      <p className="text-sm my-1">Whatsapp Number</p>
                      <input
                        type="text"
                        id="phone"
                        name="phone"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        placeholder="Whatsapp number"
                        value={newsPost.phone}
                        onChange={handleInput}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="mx-auto max-w-md">
                      <p className="text-sm my-1">Project</p>
                      <textarea
                        type="text"
                        id="details"
                        name="message"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        placeholder="Tell about your project"
                        value={newsPost.message}
                        onChange={handleInput}
                      />
                    </div>
                  </div>

                  <div className="pt-5 md:pt-10 text-center">
                    <button className="bg-transparent text-darkColor py-2 px-5 rounded border border-darkColor text-sm md:text-base hover:bg-darkColor hover:text-white">
                      {homepageVal.landing_booking_button_label}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <div className="text-center w-56">
          <FaCheckCircle size={56} className="mx-auto text-green-500" />
          <div className="mx-auto my-4 w-48">
            <h3 className="text-lg font-semibold text-gray-800">
              Congratulations
            </h3>
            <p className="text-sm text-gray-500">Your data has been added!</p>
          </div>
          <div className="flex gap-4">
            <button
              className="border py-2 bg-darkColor text-white w-full rounded-lg"
              onClick={() => setOpenModal(false)}
            >
              Ok
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};
